import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-70">
      <div className="max-w-5xl mx-auto" data-id="element-71">
        <FadeIn data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-73">
            Por qué lo que has intentado no ha funcionado
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-74">
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-75">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-76" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-77">
                Beber agua sin orden
              </h3>
              <p className="text-gray-700 text-center" data-id="element-78">
                Inundar tus riñones sin los electrolitos correctos solo los
                obliga a trabajar el doble.
              </p>
            </div>
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-79">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-80" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-81">
                Dietas genéricas
              </h3>
              <p className="text-gray-700 text-center" data-id="element-82">
                Lo que es "sano" para otros (como las espinacas o el plátano)
                puede ser veneno para tus riñones bajo estrés.
              </p>
            </div>
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-83">
              <XCircle className="text-red-500 w-12 h-12 mb-6 mx-auto" data-id="element-84" />
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-85">
                Esperar pasivamente
              </h3>
              <p className="text-gray-700 text-center" data-id="element-86">
                El tejido renal que se cicatriza no se recupera. Cada día de
                inflamación cuenta.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-87">
          <div className="bg-forest text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-88">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-y-1/2 translate-x-1/3 blur-3xl" data-id="element-89"></div>

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 relative z-10" data-id="element-90">
              El Lavado de Limpieza Profunda
            </h2>
            <p className="text-xl text-center text-cream/90 mb-12 relative z-10 max-w-3xl mx-auto" data-id="element-91">
              Este protocolo utiliza un sistema de 3 capas diseñado para dar
              resultados en 14 días:
            </p>

            <div className="space-y-6 relative z-10" data-id="element-92">
              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-93">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-94">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-97">
                    Nutrición de Rescate
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-98">
                    Alimentos que actúan como imanes de toxinas nitrogenadas.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-99">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-100">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-103">
                    Hidratación Osmótica
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-104">
                    Una fórmula de agua alcalinizada que neutraliza la acidez de
                    tu sangre.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm" data-id="element-105">
                <div className="bg-amber p-4 rounded-full shrink-0" data-id="element-106">
                  <CheckCircle2 className="text-white w-8 h-8" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <h3 className="text-2xl font-bold mb-2 text-amber" data-id="element-109">
                    Suplementación de Escudo
                  </h3>
                  <p className="text-lg text-cream/90" data-id="element-110">
                    Compuestos naturales que desinflaman el glomérulo de
                    inmediato.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}